import React from 'react';
import evemts from 'utils/evemts';
import http from 'utils/http';
import { setDeleteAction } from 'store/actions/deleteAction';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import SelectHolidayModal from './SelectHolidayModal';
import ServiceCatalog from './ServiceCatalog';
import AdditionalServiceModal from './AdditionalServiceModal';
import TimingModal from './TimingModal';
import EffectiveDetailsModal from './EffectiveDetailsModal';

class ServiceCatalogContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      services: [],
      modal: false,
      action: false,
      serviceFields: {},
      serviceFieldsErrors: {},
      selectedHolidays: [],
      holidayDates: [],
      timings: [],
      serviceFieldsValue: {},
      splCodes: [],
    };
    this.eventSource = null;
  }

  componentDidMount() {
    this.fetchServices();
    this.fetchHolidays();
    this.fetchTimings();
    this.fetchSplCodes();
    this.eventSource = evemts('admin', 'import');
    this.eventSource.onmessage = (event) => {
      const msg = JSON.parse(event.data || '{}');
      if (msg.data) {
        if (msg.action == 'ADD') {
          this.setState({
            services: [...this.state.services || [], msg.data],
            serviceFields: msg.data,
          });
        }
        if (msg.action == 'UPDATE') {
          const services = [...this.state.services || []];
          const index = services.findIndex(c => msg.data && c.id == msg.data.id);
          if (index > -1) {
            services[index] = { ...msg.data };
            this.setState({
              services,
              serviceFields: msg.data,
            });
          }
          if (this.state.serviceFields.id == msg.data.id) {
            this.setState({ serviceFields: { ...msg.data } });
          }
        }
      }
      if (msg.data && msg.action && msg.action == 'DELETE') {
        const services = [...this.state.services || []];
        const index = services.findIndex(c => msg.data && c.id == msg.data.id);
        if (index > -1) {
          services.splice(index, 1);
          this.setState({
            services,
            serviceFields: services[index - 1] || services[0],
          });
        }
      }
      if (msg.data && msg.action && msg.action == 'holidays') {
        this.setState({ selectedHolidays: msg.data?.value || [] });
      }
    };
  }

  componentWillUnmount() {
    if (this.eventSource) {
      this.eventSource.close();
    }
  }

  fetchServices = () => {
    http.get('additional_services').then((res) => {
      if (res.data) {
        this.setState({ services: res.data?.data || [] });
        this.handleOpen('', 'edit', res.data?.data[0]);
      }
    });
  };

  handleOpen = (modal, action, row = { value: [{}] }) => {
    this.setState({
      modal: action == 'add' ? modal : false,
      action,
      serviceFields: row || {},
      serviceFieldsErrors: {},
    });
  };

  handleOpenDialog = (modal, data={}) => {
    this.setState({
      modal,
      serviceFieldsValue: data 
    });
  };

  addOperation = () => {
    this.setState({
      serviceFields: {
        ...this.state.serviceFields,
        value: [...this.state.serviceFields.value, {}]
      },
    });
  };

  removeOperation = (index) => {
    let value = [...this.state.serviceFields.value];
    value.splice(index, 1);
    this.setState({
      serviceFields: {
        ...this.state.serviceFields,
        value
      },
    });
  };

  onClose = () => {
    this.setState({
      modal: false,
      action: false,
      serviceFields: {},
      serviceFieldsErrors: {},
    });
  };

  onCloseCalendar = () => {
    this.setState({
      modal: false,
      action: false,
    }, () => {
      this.fetchHolidays();
    });
  };

  onChange = (e) => {
    let value = e.target.value;
    if (e.target.type == 'checkbox') {
      value = e.target.checked;
    }
    // if(e.target.name == 'spl_code')
    // {
    //   value = value.join(',');
    // }
    this.setState({
      serviceFields: {
        ...this.state.serviceFields,
        [e.target.name]: value,
      },
    });
  };

  onChangeOperation = (index, e) => {
    let value = e.target.value;
    if (e.target.type == 'checkbox') {
      value = e.target.checked;
    }
    let operations = [...this.state.serviceFields.value];
    operations[index][e.target.name] = value;
    if (e.target.name == 'unit' && value == 'kg_per_day') {
      operations[index].unit_divisor = 1;
      operations[index].free_days = 0;
    }
    this.setState({
      serviceFields: {
        ...this.state.serviceFields,
        value: operations,
      },
    });
  };

  validateForm = () => {
    let serviceFieldsErrors = {};
    let isValid = true;
    if (!this.state.serviceFields.description) {
      serviceFieldsErrors.description = true;
      isValid = false;
    }
    if (!this.state.serviceFields.key) {
      serviceFieldsErrors.key = true;
      isValid = false;
    }
    serviceFieldsErrors.value = [];
    if (this.state.serviceFields.value && this.state.serviceFields.value.length > 0) {
      this.state.serviceFields.value.forEach((operation, index) => {
        serviceFieldsErrors.value[index] = {};
        if (!operation.type) {
          serviceFieldsErrors.value[index] = { type: true };
          isValid = false;
        }
        if (!operation.unit) {
          serviceFieldsErrors.value[index].unit = true;
          isValid = false;
        } else {
          if (operation.unit == 'number') {
            if (!operation.unit_key) {
              serviceFieldsErrors.value[index].unit_key = true;
              isValid = false;
            }
            if (!operation.cost_per_unit) {
              serviceFieldsErrors.value[index].cost_per_unit = true;
              isValid = false;
            }
          }
          if (operation.unit == 'kg') {
            if (!operation.cost_per_unit) {
              serviceFieldsErrors.value[index].cost_per_unit = true;
              isValid = false;
            }
          }
          if (operation.unit == 'cost') {
            if (!operation.cost) {
              serviceFieldsErrors.value[index].cost = true;
              isValid = false;
            }
          }
          if (operation.unit == 'percent') {
            if (!operation.percent) {
              serviceFieldsErrors.value[index].percent = true;
              isValid = false;
            }
            if (!operation.from_service) {
              serviceFieldsErrors.value[index].from_service = true;
              isValid = false;
            }
          }
          if (operation.unit == 'kg_per_day') {
            if (!operation.unit_divisor) {
              serviceFieldsErrors.value[index].unit_divisor = true;
              isValid = false;
            }
            if (!operation.cost_per_unit) {
              serviceFieldsErrors.value[index].cost_per_unit = true;
              isValid = false;
            }
            if (!operation.mim_cost_per_day) {
              serviceFieldsErrors.value[index].mim_cost_per_day = true;
              isValid = false;
            }
            if (operation.free_days === undefined || operation.free_days === null || String(operation.free_days).trim() === '') {
              serviceFieldsErrors.value[index].free_days = true;
              isValid = false;
            }
          }
        }
      });
    } else {
      serviceFieldsErrors.value_remark = 'At least one operation is required';
      isValid = false;
    }
    if (this.state.serviceFields.is_spl && (!this.state.serviceFields.spl_code || this.state.serviceFields.spl_code === '')) {
      serviceFieldsErrors.spl_code = true;
      isValid = false;
    }
    this.setState({ serviceFieldsErrors });
    return isValid;
  };

  addService = (e) => {
    e.preventDefault();
    if (this.validateForm()) {
      let data = {
        description: this.state.serviceFields.description,
        key: this.state.serviceFields.key,
        master: this.state.serviceFields.master || null,
        default: this.state.serviceFields.default || false,
        reason: this.state.serviceFields.reason || false,
        add_info: this.state.serviceFields.add_info || false,
        value: this.state.serviceFields.value,
        is_spl: this.state.serviceFields.is_spl || false,
        spl_code: this.state.serviceFields.spl_code || null,
      };
      http.post('additional_services', data).then((res) => {
        if (res.data) {
          this.setState({
            modal: false,
            action: false,
          });
        }
      });
    }
  };

  editService = (e) => {
    e.preventDefault();
    if (this.validateForm()) {
      let data = {
        description: this.state.serviceFields.description,
        key: this.state.serviceFields.key,
        master: this.state.serviceFields.master || null,
        default: this.state.serviceFields.default || false,
        reason: this.state.serviceFields.reason || false,
        add_info: this.state.serviceFields.add_info || false,
        value: this.state.serviceFields.value,
        is_spl: this.state.serviceFields.is_spl || false,
        spl_code: this.state.serviceFields.spl_code || null,
      };
      http.put(`additional_services/${this.state.serviceFields.id}`, data).then((res) => {
        if (res.data) {
          //success
          this.setState({
            modal: false,
            action: false,
          });
        }
      });
    }
  };

  handleDeleteService = (id, anchorEl) => {
    this.props.setDelete({
      modal: true,
      id,
      anchorEl,
      onConfirm: () => this.deleteService(id),
    });
  };

  deleteService = (id) => {
    http.delete(`additional_services/${id}`).then((res) => {
      if (res.data) {
        this.props.setDelete({
          modal: false,
          id: false,
          anchorEl: false,
          onConfirm: () => { },
        });
      }
    });
  };

  fetchHolidays = () => {
    http.get('settings?key=holidays', { headers: { hideloader: true } }).then(({ data }) => {
      if (data.data) {
        let holidays = data.data.find((item) => item.key === 'holidays');
        if (holidays) {
          this.setState({
            holidayDates: holidays?.value || [],
            selectedHolidays: holidays?.value || []
          });
        }
      }
    });
  };

  fetchTimings = () => {
    http.get('station_timing', { headers: { hideloader: true } }).then(({ data }) => {
      if (data.data) {
        this.setState({ timings: data.data || [] });
      }
    });
  };

  fetchSplCodes = () => {
    http.get('station/spl_code', { headers: { hideloader: true } }).then(({ data }) => {
      if (data.data) {
        this.setState({ splCodes: data.data || [] });
      }
    });
  };

  handleSubmitHolidays = (e) => {
    e.preventDefault();
    http.put('setting/holidays', { value: this.state.selectedHolidays }).then(() => {
      this.onCloseCalendar();
    });
  };

  handleHolidays = (e) => {
    let value = dayjs(e.$d).format('YYYY-MM-DD');
    let selectedHolidays = [...this.state.selectedHolidays];
    if (selectedHolidays.includes(value)) {
      selectedHolidays = selectedHolidays.filter(day => day !== value);
    } else {
      selectedHolidays.push(value);
    }

    this.setState({ selectedHolidays });
  };

  removeHoliday = (date) => {
    let selectedHolidays = [...this.state.selectedHolidays];
    let dateIndex = selectedHolidays.findIndex(item => item === date);
    selectedHolidays.splice(dateIndex, 1);
    this.setState({ selectedHolidays });
  };

  handleTimeChange = (e, id, field) => {
    let timings = [...this.state.timings];
    let index = timings.findIndex(t => t.id == id);
    if (index > -1) {
      timings[index][field] = e.target.value;
      http.put('station_timing/' + id, timings[index]).then(() => {
        this.setState({ timings });
      });
    }
  };

  render() {
    return (
      <>
        <ServiceCatalog
          consignees={this.state.consignees}
          onDelteConsignee={this.onDelteConsignee}
          mails={this.state.mails}
          onChangeMail={this.onChangeMail}
          editMail={this.editMail}
          mailFields={this.state.mailFields}
          mailFieldsErrors={this.state.mailFieldsErrors}
          onRowMailClick={this.onRowMailClick}
          swap={this.swap}
          footer={this.state.footer}
          footerErrors={this.state.footerErrors}
          onChangeFooter={this.onChangeFooter}
          saveMailFooter={this.saveMailFooter}
          handleDeleteMail={this.handleDeleteMail}

          modal={this.state.modal}
          onClose={this.onClose}

          action={this.state.action}
          serviceFields={this.state.serviceFields}
          serviceFieldsErrors={this.state.serviceFieldsErrors}
          onChange={this.onChange}
          addService={this.addService}
          editService={this.editService}
          onChangeOperation={this.onChangeOperation}
          handleOpen={this.handleOpen}
          handleDeleteService={this.handleDeleteService}
          services={this.state.services}
          addOperation={this.addOperation}
          removeOperation={this.removeOperation}
          handleOpenDialog={this.handleOpenDialog}
          splCodes={this.state.splCodes}
        />

        <AdditionalServiceModal
          modal={this.state.modal}
          action={this.state.action}
          serviceFields={this.state.serviceFields}
          serviceFieldsErrors={this.state.serviceFieldsErrors}
          splCodes={this.state.splCodes}
          onChange={this.onChange}
          addService={this.addService}
          editService={this.editService}
          onClose={this.onClose}
          services={this.state.services}
          addOperation={this.addOperation}
          removeOperation={this.removeOperation}
          onChangeOperation={this.onChangeOperation}
        />

        <SelectHolidayModal
          modal={this.state.modal}
          action={this.state.action}
          onClose={this.onCloseCalendar}
          handleHolidays={this.handleHolidays}
          selectedHolidays={this.state.selectedHolidays}
          handleSubmitHolidays={this.handleSubmitHolidays}
          removeHoliday={this.removeHoliday}
        />
        
        <TimingModal
          modal={this.state.modal}
          onClose={this.onClose}
          timings={this.state.timings}
          handleTimeChange={this.handleTimeChange}
        />

        <EffectiveDetailsModal
          modal={this.state.modal}
          onClose={this.onCloseCalendar}
          onChangeOperation={this.onChangeOperation}
          serviceFieldsErrors={this.state.serviceFieldsErrors}
          serviceFieldsValue={this.state.serviceFieldsValue}
          action={this.state.action}
          addService={this.addService}
          editService={this.editService}
        />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return { setDelete: (data) => dispatch(setDeleteAction(data)) };
};

export default connect(null, mapDispatchToProps)(ServiceCatalogContainer);